module.exports = __webpack_public_path__ + "static/media/Bell_beaker_lba_scotland_text_02.eb42075f.jpg";